import { render, staticRenderFns } from "./CoverMenu.vue?vue&type=template&id=c28428e2&"
import script from "./CoverMenu.vue?vue&type=script&lang=js&"
export * from "./CoverMenu.vue?vue&type=script&lang=js&"
import style0 from "./CoverMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoverMenu.vue"
export default component.exports